module.exports = __webpack_public_path__ + "static/media/shopping-cart-regular 1.74e4200b.svg";